export const Done = (value?: any) => Object({ value: value, done: true });